<div class="flex justify-between text-xl">
    <div class="flex items-center">
        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-amber-500 shrink-0">
            <mat-icon class="text-white icon-size-5" [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
        </div>
        <h1 class="ml-3 font-semibold">{{ data.title }}</h1>
    </div>
    <tms-close-button btnClass="-mt-1 -mr-3" (click)="dismiss()" />
</div>
<div class="w-full mt-3 border-t"></div>
<mat-dialog-content class="max-h-[60vh] overflow-y-auto py-4 -mr-2">
    @if (data.items.length > 0) {
        <p class="mb-3 text-secondary">{{ data.message }}</p>
        <ul class="pl-5 space-y-1 list-disc">
            @for (item of data.items; track $index) {
                <li>{{ item }}</li>
            }
        </ul>
    } @else {
        <ul class="pl-5 space-y-1 list-disc">
            <li class="whitespace-pre-line text-secondary">{{ data.message }}</li>
        </ul>
    }
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between px-0 mt-auto">
    <div class="w-full mb-4 border-t"></div>
    <tms-button [class]="'btn-outline'" (click)="cancel()">
        {{ data.cancelLabel ?? 'Cancel' }}
    </tms-button>
    <tms-button [class]="'btn-primary'" (click)="confirm()">
        {{ data.confirmLabel }}
    </tms-button>
</mat-dialog-actions>
